export default __webpack_public_path__ + "static/media/galarie3.91588288.jpg";